{
  "uplift": {
    "header": "Your trip no longer qualifies for Uplift Pay Monthly",
    "message": "Your trip details changed, and your itinerary is no longer eligible for Uplift Pay Monthly. Contact your agent if this change is an error, or ask how your trip can qualify."
  },
  "flexpay": {
    "header": "Your trip no longer qualifies for Flex Pay",
    "message": "Your trip details changed, and your itinerary is no longer eligible for Flex Pay. Contact your agent if this change is an error, or ask how your trip can qualify."
  }
}
